/*jshint esversion: 6 */
import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import queryString from 'query-string';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import * as moment from 'moment';
import * as axios from 'axios';
import ReactHighcharts from 'react-highcharts';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

function getParamodData(datetime) {
    var request = {
            dt: datetime.format('x')
        },
        url = (process.env.REACT_APP_BACKEND_URL !== undefined) ?
        process.env.REACT_APP_BACKEND_URL : 'http://localhost:8888/api/v1/paramod/';

    return axios.post(
        url, request, {
            withCredentials: true
        });
}
class App extends Component {

    constructor(props) {
        var now = moment();
        super(props);
        this.state = {
            datetime: now,
            data: null
        };

    }

    componentDidMount() {
        var self = this,
            now = moment();
        if (this.state.data === null) {
            getParamodData(now).then(function (response) {
                var udt = moment(response.data.dt).format('x');
                self.setState({
                    datetime: udt,
                    data: response.data.data
                });
            });
        }
    }
    onDateChange(event, picker) {
        var self = this;

        getParamodData(picker.startDate).then(function (response) {
            var udt = moment(response.data.dt).format('x');
            self.setState({
                datetime: udt,
                data: response.data.data
            });
        });
    }

    render() {
        var title = moment.unix(this.state.datetime / 1000).format("YYYY-MM-DD HH:00"),
            values = queryString.parse(this.props.location.search),
            config = {
                title: {
                    text: (values.view !== 'date' && values.view !== 'full') ? title : '',
                    style: {
                        fontWeight: 'bold',
                        fontSize: '14px'
                    }
                },
                chart: {
                    height: (9 / 8 * 100) + '%',
                    plotBorderWidth: 2,
                    type: 'scatter'
                },
                plotOptions: {
                    lineWidth: 2,
                    series: {
                        color: 'darkblue',
                        marker: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    enabled: false
                },
                legend: {
                    enabled: false
                },
                series: [],
                xAxis: {
                    reversed: true,
                    max: 15,
                    min: -35,
                    gridLineWidth: 2,
                    tickAmount: 11,
                    title: {
                        text: "X, R<sub>e</sub>",
                        useHTML: true,
                        style: {
                            fontWeight: 'bold',
                            fontSize: '12px'
                        }
                    },
                    labels: {
                        align: 'center',
                        useHTML: true,
                        style: {
                            fontWeight: 'bold',
                            fontSize: '11px'
                        }
                    }
                },
                yAxis: {
                    max: 30,
                    min: -30,
                    gridLineWidth: 2,
                    title: {
                        text: "Z, R<sub>e</sub>",
                        useHTML: true,
                        style: {
                            fontWeight: 'bold',
                            fontSize: '12px'
                        }
                    },
                    labels: {
                        align: 'center',
                        useHTML: true,
                        style: {
                            fontWeight: 'bold',
                            fontSize: '11px'
                        }
                    }
                }
            };

        console.log(title);

        if (this.state.data !== null) {
            this.state.data.map(function (d) {
                if (d.length !== 0) {
                    config.series.push({
                        lineWidth: 2,
                        data: d,
                        marker: {
                            enabled: false,
                            states: {
                                hover: {
                                    enabled: false
                                }
                            }
                        }
                    });
                }
            });
            // config.title.text = ;
        }

        return (
            <div className="App"> {
                (values.view === 'date' || values.view === 'full') ?  (
                    <DateRangePicker 
                        startDate = {moment.unix(this.state.datetime / 1000)}
                        alwaysShowCalendars = {true}
                        showDropdowns = {true}
                        singleDatePicker = {true}
                        timePicker = {true}
                        timePicker24Hour = {true}
                        timePickerIncrement = {60}
                        onApply = {this.onDateChange.bind(this)}
                    >
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <span>
                                    <FontAwesomeIcon icon={faCalendarAlt} size="2x" /> 
                                </span>
                            </InputGroupAddon>
                            <Input placeholder={moment.unix(this.state.datetime / 1000).format("YYYY-MM-DD HH:00")} />
                        </InputGroup>
                    </DateRangePicker>
                ) : null
                }
                <ReactHighcharts config={config}></ReactHighcharts>
            </div>
        );
    }
}

export default App;